<template>
  <v-tab-item v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </v-tab-item>
</template>
<script>
export default {
  inheritAttrs: false
}
</script>
